import Styles from './ReviewTemplates.module.scss'
import { ReviewTemplate } from 'types'
import { IconButton } from 'components/IconButton/IconButton'
import { ReactComponent as EditIcon } from 'assets/icons/edit16.svg'
import { useUpdateReviewTemplate } from 'hooks/queries/reviewTemplates/useUpdateReviewTemplate'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { templateToFormData } from 'components/ReviewTemplateFormModal/ReviewTemplateForm/utils'
import { TemplateSubmissionFields } from 'components/ReviewTemplateFormModal/Types'
import { useModals } from 'almanac-ui/Modal'
import { NewReviewTemplateFormModal } from 'components/ReviewTemplateFormModal/NewReviewTemplateFormModal'

interface Props {
  template: ReviewTemplate
  className: string
}

export const EditButton = ({ template, className }: Props) => {
  const { openModal } = useModals()
  const { mutate: updateReviewTemplate } = useUpdateReviewTemplate({
    workspaceId: template.workspace_id,
    templateId: template.id,
  })
  const handleSubmit = async (template: TemplateSubmissionFields) => {
    updateReviewTemplate(template, {
      onError: () => {
        showToastMessage('Failed to save template', 'error')
      },
      onSuccess: () => {
        showToastMessage('Template saved')
      },
    })
  }

  return (
    <IconButton
      className={className}
      variant="tertiary"
      icon={EditIcon}
      size="sm"
      aria-label={`Edit ${template.name}`}
      iconClassName={Styles.iconButton}
      onPress={() =>
        openModal(NewReviewTemplateFormModal, {
          initialTemplate: templateToFormData(template),
          onSubmit: handleSubmit,
        })
      }
    />
  )
}
